<template>
    <div style="width: 100%; height: 100%;">
        <div ref="chart" :style="{ width: '100%', height: '100%' }"></div>
    </div>
</template>

<script>
import * as echarts from "echarts";

export default {
    props: {
        boxPlotData: { type: Array, default: () => [] },
        pointInfo: { type: Object, default: () => {} },
    },
    components: {},
    data() {
        return {
            chart: null,
            xAxisLabel: null,
        };
    },
    watch: {
        boxPlotData: {
            async handler(newVal) {
                this.chartData = newVal;
                await this.initChart();
            },
        },
    },
    async mounted() {
        this.chartData = this.boxPlotData;
        this.xAxisLabel = [this.pointInfo.ptName];
        await this.initChart();
        this.$nextTick(() => {
            window.addEventListener("resize", this.resizeChart);
        });
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeChart);
    },
    destroyed() {
        if (this.chart) {
            this.chart.dispose();
            this.chart = null;
        }
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$refs.chart);

            const option = {
                dataset: [
                    {
                        source: [this.chartData],
                    },
                    {
                        transform: {
                            type: "boxplot",
                            config: {
                                itemNameFormatter: () => this.xAxisLabel[0] ?? "-",
                            },
                        },
                    },
                ],
                tooltip: {
                    trigger: "item",
                    confine: false,
                    position: "top",
                    axisPointer: {
                        type: "shadow",
                    },
                    formatter: (param) => {
                        const values = param.data;

                        const _valueFormat = (val) => {
                            return val % 1 === 0 ? val : val.toFixed(1);
                        };

                        return `
                            <div style='width: 200px'>
                                <div>
                                    ${param.marker}
                                    <span class='m-0 p-0'>${values[0]}</span>
                                </div>
                                <div style='display: flex; justify-content: space-between;'>
                                    <span>최대값</span>
                                    <span class='m-0 p-0' style="font-weight: bold;">${_valueFormat(values[5])}</span>
                                </div>
                                <div style='display: flex; justify-content: space-between;'>
                                    <span>Q3</span>
                                    <span class='m-0 p-0' style="font-weight: bold;">${_valueFormat(values[4])}</span>
                                </div>
                                <div style='display: flex; justify-content: space-between;'>
                                    <span>중간값</span>
                                    <span class='m-0 p-0' style="font-weight: bold;">${_valueFormat(values[3])}</span>
                                </div>
                                <div style='display: flex; justify-content: space-between;'>
                                    <span>Q1</span>
                                    <span class='m-0 p-0' style="font-weight: bold;">${_valueFormat(values[2])}</span>
                                </div>
                                <div style='display: flex; justify-content: space-between;'>
                                    <span>최소값</span>
                                    <span class='m-0 p-0' style="font-weight: bold;">${_valueFormat(values[1])}</span>
                                </div>
                            </div>
                        `;
                    },
                },
                grid: {
                    top: 30,
                    bottom: 30,
                },
                xAxis: {
                    type: "category",
                },
                yAxis: {
                    type: "value",
                },
                series: [
                    {
                        type: "boxplot",
                        datasetIndex: 1,
                    },
                ],
            };

            this.chart.setOption(option);
        },
        resizeChart() {
            if (this.chart) {
                this.chart.resize();
            }
        },
    },
};
</script>

<style scoped></style>
